(function () {
  var TRANSITION_DELAY = 350;
  var wrapper = document.querySelector('[data-coloo-quiz]');
  if (!wrapper) return;

  var questions = JSON.parse(wrapper.dataset.questions || '[]');
  var results = JSON.parse(wrapper.dataset.results || '[]');
  var questionEls = wrapper.querySelectorAll(
    '.ctm-block-choice-quiz__question',
  );
  var dots = wrapper.querySelectorAll('.ctm-block-choice-quiz__dot');
  var resultEls = wrapper.querySelectorAll('.ctm-block-choice-quiz__result');
  var nav = wrapper.querySelector('.ctm-block-choice-quiz__nav');
  var counter = wrapper.querySelector('.ctm-block-choice-quiz__counter');
  var completedEl = wrapper.querySelector(
    '.ctm-block-choice-quiz__completed',
  );
  var counterTemplate = wrapper.dataset.counterTemplate || 'Vraag %1$d van %2$d';
  var scores = [];
  var isTransitioning = false;

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  function updateCounter(index) {
    if (counter) {
      counter.textContent = counterTemplate
        .replace('%1$d', index + 1)
        .replace('%2$d', questions.length);
    }
  }

  function showQuestion(index) {
    questionEls.forEach(function (q, i) {
      q.classList.remove('active', 'slide-in-left', 'slide-in-right');
      if (i === index) {
        q.classList.add('active');
      }
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i <= index);
    });
    updateCounter(index);
    focusFirstOption(index);
  }

  function focusFirstOption(index) {
    var activeQ = questionEls[index];
    if (activeQ) {
      var firstOption = activeQ.querySelector(
        '.ctm-block-choice-quiz__option',
      );
      if (firstOption) firstOption.focus();
    }
  }

  function animateToQuestion(index, direction) {
    if (isTransitioning) return;
    isTransitioning = true;

    var current = wrapper.querySelector(
      '.ctm-block-choice-quiz__question.active',
    );
    if (current) current.classList.remove('active');

    var next = questionEls[index];
    if (next) {
      next.classList.add(
        'active',
        direction === 'forward' ? 'slide-in-right' : 'slide-in-left',
      );
    }

    dots.forEach(function (d, i) {
      d.classList.toggle('active', i <= index);

      // Pulse animation on the newly activated dot
      if (i === index && direction === 'forward' && !prefersReducedMotion) {
        d.classList.add('pulse');
        setTimeout(function () {
          d.classList.remove('pulse');
        }, 400);
      }
    });

    updateCounter(index);

    setTimeout(function () {
      isTransitioning = false;
      focusFirstOption(index);
    }, prefersReducedMotion ? 50 : 300);
  }

  function findResult(total) {
    for (var i = 0; i < results.length; i++) {
      if (total >= results[i].minScore && total <= results[i].maxScore) {
        return results[i].id;
      }
    }
    return results.length ? results[0].id : '';
  }

  function showResult() {
    var total = scores.reduce(function (a, b) {
      return a + b;
    }, 0);
    var resultId = findResult(total);

    questionEls.forEach(function (q) {
      q.classList.remove('active', 'slide-in-left', 'slide-in-right');
    });
    nav.style.display = 'none';

    if (completedEl) {
      completedEl.classList.add('active');
    }

    resultEls.forEach(function (r) {
      var isMatch = r.dataset.result === resultId;
      if (isMatch) {
        r.classList.add('active');

        // Staggered reveal: add class to trigger child animations
        if (!prefersReducedMotion) {
          r.classList.add('stagger');
        }

        setTimeout(function () {
          r.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      } else {
        r.classList.remove('active', 'stagger');
      }
    });

    document.body.dataset.quizResult = resultId;

    document.dispatchEvent(
      new CustomEvent('coloo:quiz:result', {
        detail: { total: total, resultId: resultId, scores: scores.slice() },
      }),
    );
  }

  function restart() {
    scores.length = 0;
    isTransitioning = false;

    resultEls.forEach(function (r) {
      r.classList.remove('active', 'stagger');
    });
    nav.style.display = '';

    if (completedEl) {
      completedEl.classList.remove('active');
    }

    delete document.body.dataset.quizResult;

    wrapper
      .querySelectorAll('.ctm-block-choice-quiz__option')
      .forEach(function (btn) {
        btn.setAttribute('aria-checked', 'false');
        btn.classList.remove('selected');
      });

    wrapper
      .querySelectorAll('.ctm-block-choice-quiz__options')
      .forEach(function (group) {
        group.classList.remove('has-selection');
      });

    showQuestion(0);
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

    document.dispatchEvent(new CustomEvent('coloo:quiz:restart'));
  }

  function goBack() {
    if (scores.length === 0 || isTransitioning) return;
    scores.pop();

    var prevIndex = scores.length;
    var prevQuestion = questionEls[prevIndex];
    if (prevQuestion) {
      prevQuestion
        .querySelectorAll('.ctm-block-choice-quiz__option')
        .forEach(function (btn) {
          btn.setAttribute('aria-checked', 'false');
          btn.classList.remove('selected');
        });
      var optionsGroup = prevQuestion.querySelector(
        '.ctm-block-choice-quiz__options',
      );
      if (optionsGroup) optionsGroup.classList.remove('has-selection');
    }

    animateToQuestion(prevIndex, 'backward');
  }

  wrapper
    .querySelectorAll('.ctm-block-choice-quiz__option')
    .forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isTransitioning) return;

        btn.setAttribute('aria-checked', 'true');
        btn.classList.add('selected');

        // Mark the options group so unselected siblings dim
        var optionsGroup = btn.closest('.ctm-block-choice-quiz__options');
        if (optionsGroup) optionsGroup.classList.add('has-selection');

        var siblings = btn.parentNode.querySelectorAll(
          '.ctm-block-choice-quiz__option',
        );
        siblings.forEach(function (s) {
          if (s !== btn) {
            s.setAttribute('aria-checked', 'false');
            s.classList.remove('selected');
          }
        });

        scores.push(parseInt(btn.dataset.score, 10));

        var delay = prefersReducedMotion ? 100 : TRANSITION_DELAY;

        setTimeout(function () {
          if (scores.length < questions.length) {
            animateToQuestion(scores.length, 'forward');
          } else {
            showResult();
          }
        }, delay);
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

  wrapper
    .querySelectorAll('.ctm-block-choice-quiz__back')
    .forEach(function (b) {
      b.addEventListener('click', goBack);
    });

  wrapper
    .querySelectorAll('.ctm-block-choice-quiz__restart')
    .forEach(function (b) {
      b.addEventListener('click', restart);
    });
})();
